import MuiCircularProgress from '@mui/material/CircularProgress';
import type { ComponentProps } from 'react';

export const CircularProgress = (
  props: ComponentProps<typeof MuiCircularProgress>,
) => {
  return <MuiCircularProgress {...props} />;
};
